import React from 'react';
import { motion } from 'framer-motion';
import { Server, Zap, Wifi } from 'lucide-react';

export function DataCenterIllustration() {
  return (
    <div className="relative w-64 h-64 mx-auto">
      {/* Background Grid */}
      <motion.div
        className="absolute inset-0 grid grid-cols-4 gap-2 opacity-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.1 }}
      >
        {[...Array(16)].map((_, i) => (
          <div
            key={i}
            className="bg-blue-500 rounded-lg"
            style={{
              animation: `pulse ${2 + Math.random() * 2}s infinite`,
              animationDelay: `${Math.random() * 2}s`
            }}
          />
        ))}
      </motion.div>

      {/* Server Racks */}
      <motion.div
        className="absolute inset-0 flex items-center justify-center"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="grid grid-cols-2 gap-4">
          {[0, 1].map((rack) => (
            <motion.div
              key={rack}
              className="relative bg-white rounded-xl p-4 shadow-lg border border-gray-200"
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: rack * 0.2 }}
            >
              <Server className="w-12 h-12 text-blue-500 mb-2" />
              {[...Array(3)].map((_, i) => (
                <motion.div
                  key={i}
                  className="h-2 bg-blue-100 rounded-full mb-1"
                  initial={{ width: 0 }}
                  animate={{ width: '100%' }}
                  transition={{ delay: rack * 0.2 + i * 0.1 }}
                />
              ))}
              <motion.div
                className="absolute -top-1 -right-1 w-3 h-3"
                animate={{ opacity: [1, 0.5, 1] }}
                transition={{ duration: 1, repeat: Infinity }}
              >
                <div className="w-full h-full bg-green-500 rounded-full" />
              </motion.div>
            </motion.div>
          ))}
        </div>
      </motion.div>

      {/* Power Lines */}
      <motion.div
        className="absolute inset-0"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
      >
        <svg className="w-full h-full" viewBox="0 0 256 256">
          <motion.path
            d="M128 50 L128 206"
            stroke="currentColor"
            strokeWidth="2"
            className="text-blue-200"
            strokeDasharray="6 6"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 2, repeat: Infinity }}
          />
        </svg>
      </motion.div>

      {/* Floating Icons */}
      {[Zap, Wifi].map((Icon, i) => (
        <motion.div
          key={i}
          className="absolute"
          style={{
            top: `${20 + i * 30}%`,
            left: `${70 + i * 20}%`,
          }}
          animate={{
            y: [-10, 10, -10],
            rotate: [-10, 10, -10],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            delay: i * 0.5,
          }}
        >
          <Icon className="w-6 h-6 text-blue-400" />
        </motion.div>
      ))}
    </div>
  );
}